import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CircleCheckIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00032C14.1663 4.59467 11.4059 1.8335 8.00032 1.83333C4.59456 1.83333 1.83333 4.59456 1.83333 8.00032C1.8335 11.4059 4.59467 14.1663 8.00032 14.1663C11.4058 14.1662 14.1662 11.4058 14.1663 8.00032ZM15.1663 8.00032C15.1662 11.9581 11.9581 15.1662 8.00032 15.1663C4.04239 15.1663 0.833504 11.9582 0.833328 8.00032C0.833328 4.04228 4.04228 0.833328 8.00032 0.833328C11.9582 0.833504 15.1663 4.04239 15.1663 8.00032Z"
      fill="currentColor"
    />
    <path
      d="M9.64649 6.31315C9.84175 6.11789 10.1583 6.11789 10.3535 6.31315C10.5488 6.50841 10.5488 6.82492 10.3535 7.02018L7.68653 9.68717C7.49124 9.88211 7.17465 9.88233 6.9795 9.68717L5.64649 8.35319C5.45139 8.15791 5.45128 7.84136 5.64649 7.64616C5.84171 7.45111 6.1583 7.45111 6.35352 7.64616L7.33301 8.62565L9.64649 6.31315Z"
      fill="currentColor"
    />
  </svg>
);
